export enum Locale {
  EN_US = 'en-US',
  FR = 'fr-FR',
  FR_CA = 'fr-CA',
  ES = 'es-ES',
  PT = 'pt-PT',
  DE = 'de-DE',
  JA_JP = 'ja-JP',
}
